import React, { useContext, useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom'
import MainApp from './MainApp'
import { GlobalContext } from './context/GlobalContext'
import useAuth from './hooks/useAuth'
import { getApir, getCinfo, token } from './lib/haxios'
import Loading from './components/Loading'
import './lib/modals'
import useLockStore, { useLockConnection } from './stores/useLockStore'
import useNotificationStore from './stores/useNotificationStore'
import { debugWebSocket } from './lib/debugUtils'

function App() {
  const navigate = useNavigate()
  const { setCinfo, setLoginError, setApir } = useContext(GlobalContext)
  const [isLoading, setLoading] = useState(true)
  const { isAuthed } = useAuth()
  const { notify } = useNotificationStore()

  // Start debug monitoring
  useEffect(() => {
    console.log('🔍 Starting WebSocket debug monitoring...')
    const cleanupChrome = debugWebSocket.monitorChromeErrors()
    const cleanupWS = debugWebSocket.monitorExtensions()
    debugWebSocket.generateReport()

    return () => {
      cleanupChrome()
      cleanupWS()
    }
  }, [])
  const connectWebsocket = useLockStore((state) => state.connect)

  useEffect(() => {
    if (isAuthed === null) return

    if (isAuthed === false) {
      navigate('/')
      setLoading(false)
      return
    }

    setLoading(true)
      ; (async () => {
        const cinfo = await getCinfo()

        if (!cinfo) {
          navigate('/')
          setLoading(false)
          return
        }

        try {
          let apirUrl = ''
          if (cinfo?.CompanyID == '85be2070-f82f-42e4-9f0e-83e60427c508') {
            apirUrl = 'https://melk.connectplus.parts/api'
            console.info('Using hardcoded APIR URL for Melk')
          } else {
            apirUrl = await getApir()
            console.info('APIR URL loaded:')
          }

          if (!apirUrl) {
            throw new Error('APIR URL not loaded properly')
          } else {
            setApir(apirUrl)
          }
          const wsUrl = apirUrl.replace(/^https?:\/\//, '')
          connectWebsocket(token, notify, wsUrl)
          setCinfo(cinfo)
          console.info('cinfo', cinfo)
          if (window.location.pathname === '/') navigate('/enquiries')
        } catch (e) {
          //setLoginError(e.message);
          navigate('/')
        } finally {
          setLoading(false)
        }
      })()
  }, [isAuthed])

  if (isLoading) {
    return <Loading />
  }

  return <MainApp />
}

export default App
